import React, {useState, useEffect} from 'react';
import {Checkbox} from "react-materialize";

const UnreconciledTransaction = ({journalEntry, index, handleCheck, selectedTransactions}) => {
  const {date, type, sent, received, fee, source, transactionID, counterParty} = journalEntry;

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (checked === true) {
      let stayChecked = selectedTransactions.has(transactionID);
      if (!stayChecked) setChecked(false)
    }
  }, [selectedTransactions])

  const handleChange = () => {
    let checkedStatus = !checked;
    setChecked(checkedStatus);
    handleCheck(checkedStatus, journalEntry);
  }

  return (
    <tr>
      <div className={'check-box-td'}><div className={'children'}><Checkbox onChange={handleChange} checked={checked} id={index} value={journalEntry} /></div></div>
      <td>{date}</td>
      <td>{type}</td>
      <td>{sent.quantity} {sent.asset}</td>
      <td>{received.quantity} {received.asset}</td>
      <td>{fee.quantity} {fee.asset}</td>
      <td>{source}</td>
      <td>{transactionID}</td>
      <td>{counterParty.name}</td>
    </tr>
  )
}

export default UnreconciledTransaction;